module.exports = __webpack_public_path__ + "img/s_02.52e97b26.png";